import { render, staticRenderFns } from "./overview-cell-org-and-persons.vue?vue&type=template&id=18531d69&scoped=true"
import script from "./overview-cell-org-and-persons.vue?vue&type=script&lang=ts"
export * from "./overview-cell-org-and-persons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18531d69",
  null
  
)

export default component.exports